module.exports = __webpack_public_path__ + "img/logo-interplan.65eeda56.png";